import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'Nameless',
    name: 'Władca Plagi',
    id: 'BlightLord',
    health: 70,
    difficulty: 4,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'Nameless',
    name: 'Marnotrawny',
    id: 'WaywardOne',
    health: 60,
    difficulty: 7,
    expeditionRating: 3,
    additionalInfo: '',
  },
]
